import React from 'react';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import AuthContext from '../AppContext/AuthContext';
import AppHeader from '../Header/AppHeader';

const AppLayout = ({ children }) => {
  const {IsAuthenticated}=useContext(AuthContext);
    const Location=useLocation();
  const isSlideApp = Location.pathname === '/slideapp';
  return (
    <div className={isSlideApp || Location.pathname === '/newsletterapp' ? 'bg-[#f2efea]' : undefined}>
       {
        Location.pathname!=="/" && Location.pathname!=="/forgotpassword" && Location.pathname!=="/corporate-communities" && IsAuthenticated===true?(
            <AppHeader />
        ):(null)
       } 
       
        <main>
        {children}
        </main>
    </div>
  )
}

export default AppLayout
